(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['../ApiClient', '../model/ErrorResponse500', '../model/ErrorResponse400', '../model/Error', '../model/BlendedPackage', '../model/CreateCanonical', '../model/DependenciesList', '../model/RejectAcquisitionPackage', '../model/ResendInvite'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ErrorResponse500'), require('../model/ErrorResponse400'), require('../model/Error'), require('../model/BlendedPackage'), require('../model/CreateCanonical'), require('../model/DependenciesList'), require('../model/RejectAcquisitionPackage'), require('../model/ResendInvite'));
  } else {
    // Browser globals (root is window)
    if (!root.Swagger) {
      root.Swagger = {};
    }
    root.Swagger.PackagesApi = factory(root.Swagger.ApiClient, root.Swagger.ErrorResponse500, root.Swagger.ErrorResponse400, root.Swagger.Error, root.Swagger.BlendedPackage, root.Swagger.CreateCanonical, root.Swagger.DependenciesList, root.Swagger.RejectAcquisitionPackage, root.Swagger.ResendInvite);
  }
}(this, function(ApiClient, ErrorResponse500, ErrorResponse400, Error, BlendedPackage, CreateCanonical, DependenciesList, RejectAcquisitionPackage, ResendInvite) {
  'use strict';

  /**
   * Packages service.
   * @module api/PackagesApi
   * @version 1.0.0
   */

  /**
   * Constructs a new PackagesApi. 
   * @alias module:api/PackagesApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use, default to {@link module:ApiClient#instance}
   * if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the canonicalDownloadFile operation.
     * @callback module:api/PackagesApi~canonicalDownloadFileCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BlendedPackage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * return the file data from hub, and download to host if package is missing
     * @param {String} accountSlug slug of account
     * @param {String} slug slug of package to return.
     * @param {String} name name of the file
     * @param {String} sessionkey value used to manage user session.
     * @param {module:api/PackagesApi~canonicalDownloadFileCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/BlendedPackage}
     */
    this.canonicalDownloadFile = function(accountSlug, slug, name, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling canonicalDownloadFile";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling canonicalDownloadFile";
      }

      // verify the required parameter 'name' is set
      if (name == undefined || name == null) {
        throw "Missing the required parameter 'name' when calling canonicalDownloadFile";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling canonicalDownloadFile";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug,
        'name': name
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BlendedPackage;

      return this.apiClient.callApi(
        'packages/{accountSlug}/{slug}/canonical/documents/{name}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the canonicalSet operation.
     * @callback module:api/PackagesApi~canonicalSetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get package draft.
     * 
     * @param {String} accountSlug accountSlug
     * @param {String} slug package slug used to uniquely identify a package.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:model/CreateCanonical} body request data used to update package.
     * @param {module:api/PackagesApi~canonicalSetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.canonicalSet = function(accountSlug, slug, sessionkey, body, callback) {
      var postBody = body;

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling canonicalSet";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling canonicalSet";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling canonicalSet";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling canonicalSet";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/canonical/', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the draftDownloadFile operation.
     * @callback module:api/PackagesApi~draftDownloadFileCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BlendedPackage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * return the file data from hub, and download to host if package is missing
     * @param {String} accountSlug slug of account
     * @param {String} slug slug of package to return.
     * @param {String} name name of the file
     * @param {String} sessionkey value used to manage user session.
     * @param {module:api/PackagesApi~draftDownloadFileCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/BlendedPackage}
     */
    this.draftDownloadFile = function(accountSlug, slug, name, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling draftDownloadFile";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling draftDownloadFile";
      }

      // verify the required parameter 'name' is set
      if (name == undefined || name == null) {
        throw "Missing the required parameter 'name' when calling draftDownloadFile";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling draftDownloadFile";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug,
        'name': name
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BlendedPackage;

      return this.apiClient.callApi(
        'packages/{accountSlug}/{slug}/draft/documents/{name}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getDependencies operation.
     * @callback module:api/PackagesApi~getDependenciesCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DependenciesList} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Return package dependencies.
     * Returns package dependencies.
     * @param {String} accountSlug slug of account
     * @param {String} slug slug of package to return.
     * @param {String} sessionkey value used to manage user session.
     * @param {Object} opts Optional parameters
     * @param {String} opts.verbose parameter to provide detail view of hyperlink objects.
     * @param {module:api/PackagesApi~getDependenciesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/DependenciesList}
     */
    this.getDependencies = function(accountSlug, slug, sessionkey, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling getDependencies";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling getDependencies";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling getDependencies";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug
      };
      var queryParams = {
        'verbose': opts['verbose']
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = DependenciesList;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/dependencies/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the rejectAcquisitionInvite operation.
     * @callback module:api/PackagesApi~rejectAcquisitionInviteCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * API to acquire package between accounts.
     * to resend email invite link for given acquisition type to other account
     * @param {String} accountSlug accounts slug
     * @param {String} slug slug of package to return.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:model/RejectAcquisitionPackage} body request data used to acquire package.
     * @param {module:api/PackagesApi~rejectAcquisitionInviteCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.rejectAcquisitionInvite = function(accountSlug, slug, sessionkey, body, callback) {
      var postBody = body;

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling rejectAcquisitionInvite";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling rejectAcquisitionInvite";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling rejectAcquisitionInvite";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling rejectAcquisitionInvite";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/reject/', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the resendInvite operation.
     * @callback module:api/PackagesApi~resendInviteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BlendedPackage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * API to acquire package between accounts.
     * to resend email invite link for given acquisition type to other account
     * @param {String} accountSlug accounts slug
     * @param {String} slug slug of package to return.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:model/ResendInvite} body request data used to acquire package.
     * @param {module:api/PackagesApi~resendInviteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/BlendedPackage}
     */
    this.resendInvite = function(accountSlug, slug, sessionkey, body, callback) {
      var postBody = body;

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling resendInvite";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling resendInvite";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling resendInvite";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling resendInvite";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BlendedPackage;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/resend/invite/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the versionDownloadFile operation.
     * @callback module:api/PackagesApi~versionDownloadFileCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BlendedPackage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * return the file data from hub, and download to host if package is missing
     * @param {String} accountSlug slug of account
     * @param {String} slug slug of package to return.
     * @param {String} name name of the file
     * @param {String} sessionkey value used to manage user session.
     * @param {module:api/PackagesApi~versionDownloadFileCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/BlendedPackage}
     */
    this.versionDownloadFile = function(accountSlug, slug, name, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling versionDownloadFile";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling versionDownloadFile";
      }

      // verify the required parameter 'name' is set
      if (name == undefined || name == null) {
        throw "Missing the required parameter 'name' when calling versionDownloadFile";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling versionDownloadFile";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug,
        'name': name
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BlendedPackage;

      return this.apiClient.callApi(
        'packages/{accountSlug}/{slug}/versions/{label}/documents/{name}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));



/*****************
 ** WEBPACK FOOTER
 ** ./~/swagger/src/api/PackagesApi.js
 ** module id = 275
 ** module chunks = 0
 **/